module.exports = __webpack_public_path__ + "static/img/3.2aaa01e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/eng/3.png
// module id = OPgS
// module chunks = 0